/* eslint-disable */
import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const DevScaleArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);

  // ==========================
  // Evolvelab Scale (content)
  // Source: Evolvelab Scale.docx   [oai_citation:0‡Evolvelab Scale.docx](sediment://file_00000000298c722fb13153cf1b7f334e)
  // ==========================

  const outcomes = [
    "A clear scale-readiness assessment (what to fix first)",
    "A market-aligned product roadmap tied to revenue and growth",
    "Security, privacy, and compliance readiness for enterprise/regulated markets",
    "A pricing/monetization strategy with growth levers",
    "A partnerships pipeline + market entry plan (Canada, US, GCC, India)",
    "A sequenced 12-month execution roadmap for scale + expansion",
  ];

  const forWho = [
    "Teams with an MVP/live product or active pilots",
    "Startups pursuing enterprise readiness (security, privacy, compliance)",
    "Founders who need a clear roadmap tied to revenue + growth",
    "Companies preparing for fundraising / growth capital (without fluff)",
    "Teams expanding into new markets or building partner distribution",
  ];

  const problem = [
    "Scaling the product without clarity on what must be fixed first",
    "Roadmaps not tied to growth, revenue, or market reality",
    "Security/privacy/compliance gaps blocking enterprise sales",
    "Monetization and unit economics not optimized for growth",
    "No structured partner pipeline or market entry plan",
    "Execution is scattered across too many priorities",
  ];

  const deliverablesLeft = [
    "Product & scale readiness assessment (risks + constraints)",
    "Roadmap optimization + prioritization framework",
    "PMF revalidation + positioning/use-case insights",
    "Monetization & revenue strategy (pricing + expansion opportunities)",
    "GTM & growth alignment (KPI framework + bottleneck map)",
  ];

  const deliverablesRight = [
    "Security & data privacy review + mitigation recommendations",
    "Compliance & regulatory readiness (GDPR/HIPAA/SOC readiness mapping)",
    "Partnership pipeline + market entry strategy (Canada/US/GCC/India)",
    "12-month scale roadmap + execution sequencing plan",
    "Fractional CXO-led working sessions and documentation",
  ];

  const whyChoose = [
    "Execution-driven: product + growth + market work done with you",
    "Embedded fractional CXO team (product, AI/tech, funding, growth)",
    "Enterprise readiness focus (security/privacy/compliance)",
    "Roadmaps tied to revenue, growth, and expansion",
    "Clear sequencing so your next phase is actually actionable",
  ];

  const notIncluded = [
    "Product build, software development, coding, or UI/UX implementation",
    "Engineering execution or staff augmentation",
    "Guaranteed revenue, partnerships, or funding outcomes",
  ];

  const afterProgram = [
    "A stronger, scale-ready product foundation",
    "Reduced enterprise/regulatory risk and clearer compliance path",
    "A roadmap aligned to market demand and growth targets",
    "A monetization plan with measurable growth levers",
    "A partner + market expansion pathway you can execute",
    "A 12-month plan built for real execution (not slides)",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Funding Program
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                                    <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                                    <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                                  </ul>
                
                                  <div style={{ height: '16px' }}></div>
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Dev Accelerator
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                                    <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                                    <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                                  </ul>
                                </div>

                <div className="widget widget_author text-center">
                  
                  <div className="details">
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      onClick={() => setShowMeetings((s) => !s)}
                    >
                      Book a Scale Readiness Call +
                    </button>

                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="/assets/pdf/Evolvelab_Scale.pdf"
                        style={{ color: "#000000" }}
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Get the Scale Program Overview{" "}
                        <FaAngleDoubleRight
                          style={{ background: "rgba(170, 237, 222, 1)" }}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "#50af9b")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "rgba(170, 237, 222, 1)")
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Scale Snapshot
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Engagement: 12–16 weeks
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Fee: $30,000 – $60,000 CAD
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Focus: Product + Growth + Market Expansion
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Excludes: Product build/coding
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO */}
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                      margin: 0,
                    }}
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    >
                      <source src="/assets/video/scale.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div
                    className="details"
                    style={{ position: "relative", zIndex: 1, padding: "50px" }}
                  >
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Dev Scale</p>
                    <h1>
                      Product + Growth + Market Expansion — with embedded execution
                    </h1>

                    <p className="mb-2">
                      You already have a product in motion.
                      <br />
                      Now you need to strengthen it, de-risk it, and scale it — without
                      losing momentum.
                    </p>

                    <p>
                      Evolvelab Scale is a 12–16 week, high-touch engagement for startups
                      ready to mature the product, tighten security/compliance, unlock
                      partnerships, expand into new markets, and prepare for growth
                      capital.
                    </p>

                    {/* KEY OUTCOME LIST */}
                    <h5 className="mt-4">Outcomes you’ll walk away with:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHO IT'S FOR */}
                    <h4>Who This Is For</h4>
                    <p>Evolvelab Scale is designed for teams that:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>
                      If you want enterprise readiness and a real plan to grow — this is built
                      for you.
                    </p>

                    {/* PROBLEM */}
                    <h4>The Problem We Solve</h4>
                    <p>Scaling fails when teams try to grow on a shaky foundation:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {problem.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>
                      <b>This replaces scattered effort with a sequenced, execution-ready plan.</b>
                    </p>

                    {/* WHAT YOU GET */}
                    <h4>Scope & Deliverables (What We Actually Produce)</h4>
                    <p>
                      You’ll receive concrete deliverables across product, security/compliance,
                      growth, monetization, partnerships, and scale execution.
                    </p>

                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* TIMELINE */}
                    <h4 id="how-it-works">Timeline (12–16 Weeks)</h4>

                    <h6 className="mt-3">Weeks 1–2 — Product + Scale Assessment</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Architecture, scalability, security posture baseline
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Compliance baseline + risk identification
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> PMF baseline + constraints that block growth
                      </li>
                    </ul>

                    <h6>Weeks 3–4 — Roadmap + Monetization Alignment</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Feature prioritization tied to revenue and growth
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Positioning/ICP refinement + pricing review
                      </li>
                    </ul>

                    <h6>Weeks 5–7 — Security + Compliance Readiness</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Privacy/regulatory mapping (GDPR/HIPAA/SOC readiness)
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Gap remediation plan + mitigation recommendations
                      </li>
                    </ul>

                    <h6>Weeks 8–10 — GTM + Growth Alignment</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Growth KPIs + execution alignment
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Bottlenecks, expansion drivers, and growth levers
                      </li>
                    </ul>

                    <h6>Weeks 11–13 — Partnerships + Market Expansion</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Partner identification + pipeline creation
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Market entry planning (Canada, US, GCC, India)
                      </li>
                    </ul>

                    <h6>Weeks 14–16 — Consolidation + Execution Sequencing</h6>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> 12-month scale + expansion plan
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Next-phase plan with clear sequencing and ownership
                      </li>
                    </ul>

                    <p>
                      <b>Strategy without execution is noise. Scale is built to be usable.</b>
                    </p>

                    {/* WHY CHOOSE */}
                    <h4>What Makes Scale Different</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* PRICING */}
                    <h4 id="pricing">Pricing</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Engagement Fee:{" "}
                        <b>$30,000 – $60,000 CAD</b>
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Timeline: <b>12–16 weeks</b>
                      </li>
                      <li>
                        <FaCheckCircle style={{ color: "#50af9b" }} /> Final pricing depends on scope, product complexity, and compliance needs
                      </li>
                    </ul>
                    <p>
                      <b>Request pricing + scope fit</b> and we’ll respond with the best-fit option and a clear next-step plan.
                    </p>

                    {/* NOT INCLUDED */}
                    <h4>Exclusions (Important)</h4>
                    <p>To keep this engagement focused, it does not include:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* OUTCOME */}
                    <h4>The Outcome</h4>
                    <p>After Evolvelab Scale, you will have:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {afterProgram.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* FAQ */}
                    <h4>FAQ</h4>
                    <div
                      className="accordion accordion-inner accordion-icon-left mt-3 mb-4"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How do we start?
                          </button>
                        </h3>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Upon acceptance, we invoice and begin onboarding within 2–3
                            business days.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Is this for early-stage or later-stage?
                          </button>
                        </h3>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            It’s for startups with a product already in motion that now need
                            scale readiness, growth pathways, and commercialization.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Do you help with regulated markets?
                          </button>
                        </h3>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Yes — security, privacy, and compliance mapping/readiness is a
                            core pillar (e.g., GDPR, HIPAA, SOC readiness).
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* FINAL CONVERSION */}
                    <h4>Ready to Scale Without Chaos?</h4>
                    <p>
                      Book a Scale Readiness Call (15–30 min). Bring your deck + product link
                      (if available) — we’ll map where you are and what “scale-ready” means
                      for your market.
                    </p>

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{
                          backgroundColor: "#50af9b",
                          borderColor: "#50af9b",
                        }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Scale Readiness Call
                      </button>

                

                      <Link className="btn btn-black border-radius-5" to="/contact">
                        🚀 Request Scope + Pricing
                      </Link>
                    </div>

                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}

                    <p className="mt-4">
                      <b>
                        Execution-driven. High-touch. Built for product maturity, security/compliance,
                        partnerships, market expansion, monetization, and fundraising readiness.
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* /RIGHT CONTENT */}
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default DevScaleArea;